import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);

// Static <head> fallbacks in index.html exist for non-JS crawlers. Once Helmet
// has injected the per-route tags, drop them so each page has exactly one.
requestAnimationFrame(() => {
  document
    .querySelectorAll('head [data-static-fallback="1"]')
    .forEach((el) => el.remove());
});

